import React from "react";

// Tab key constants
const CHAT_TAB_KEY = 'Chat';
const CHAT_TAB_LABEL = 'A.I. Chat';

// dfashboard URLs
// Overview https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/a3e98610-2b2a-4f7d-ab26-19c915974f2d
// Details https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/5f38e07f-6b62-42b1-a88b-517e66a0f032
// Compare https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/6dc5c0d3-4865-4014-b222-085c0b523789
// Mention https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/37dd7f41-b48f-4e01-ae08-16be20a88591
// Segments https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/c0477054-a830-44d0-a64d-648581b869f0
// Audience https://ap-southeast-2.quicksight.aws.amazon.com/sn/dashboards/f173e61d-3246-43b1-8c06-82c755ceb11c



// Static list of navigation tabs with unique IDs and display labels
const tabs = [
    { id: '486f3ff8-c86e-4498-9e32-61c2a53c180f', label: 'Overview' },
    { id: 'dd6dd614-4b10-4090-8d91-26a2b73359db', label: 'Details' },
    { id: 'f53f98f4-0bc7-4668-bffd-7230e18b7746', label: 'Compare' },
    { id: '3ef27204-424f-4b78-b200-980e7e39f45b', label: 'Content' },
    { id: 'c461e65d-7a3f-498f-882d-c1c5290a96b6', label: 'Segments' },
    { id: '796ec552-b033-4688-86f7-eb48f56ca5bf', label: 'Audience' },
    { id: '6', label: CHAT_TAB_LABEL, key: CHAT_TAB_KEY },
];

function Navigation({ activeTab, onTabChange, isFiltersPanelCollapsed, setIsFiltersPanelCollapsed }) {
    return (
        <div className="navigation-menu flex">
            <button
              onClick={() => setIsFiltersPanelCollapsed(!isFiltersPanelCollapsed)}
              className="filters-toggle-btn font-oswald-regular font-bold"
            >
              {isFiltersPanelCollapsed ? 'Filters ›' : '‹'}
            </button>
            
            <ul className="flex m-0 p-0 list-none">
                {tabs.map(({ id, label }, index) => (
                    <li
                        key={id}
                        onClick={() => onTabChange(label)}
                        className={`font-oswald-regular cursor-pointer text-lg transition-colors duration-200 ${
                            activeTab === label 
                                ? 'text-edge-green' 
                                : 'text-white hover:text-edge-green'
                        } ${index === 0 ? 'ml-[15px]' : ''}`}
                    >
                        <span>{label}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Navigation;